import { useQuery } from "react-query";
import { getEmployeeReportsTo } from "../../../../../actions/Utilities/EmployeeReportsTo";
//import { getEmployeeTitle }  from "../../../../../actions/Utilities/EmployeeTitle";

export default function useGetEmployeeReportsTo() {
  return useQuery("GetEmployeeReportsTo", getEmployeeReportsTo, {
    refetchOnWindowFocus: false,
  });
}
